<template>
	<form-field :label="label">
		<input
			type="text"
			:value="modelValue"
			:placeholder="placeholder"
			class="form-control"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
	</form-field>
</template>

<script>
export default {
	props: {
		modelValue: String,
		label: {
			type: String,
			default: 'Search'
		},
		placeholder: {
			type: String,
			default: 'Search'
		}
	},
	emits: ['update:modelValue']
}
</script>
